module.exports = __webpack_public_path__ + "img/1699233732619-NIB RONI.png.b9aa3c9d.webp";